import type { AppKind } from "@/api/appVersions.api";

export const APP_KINDS: AppKind[] = ["RIDER", "DRIVER"];
export const APP_LABEL: Record<AppKind, string> = { RIDER: "Rider app", DRIVER: "Driver app" };
